export const educationData = [
    
    {
        degree: "PG Diploma in Advance Computing",
        college: "Center for development of advance computing, Pune",
        deciplin: "Computer programming",
        dateStart: "Aug 2018",
        dateEnd: "Jan 2019",
        collegeLink: "https://www.cdac.in/",
        courseDesc: "Learnt about general purpose computer programming including FrontEnd and BackEnd technologies along with software development life cycle methodologies and Data structures and Algorithms."
    },
    {
        degree: "Bachelor of Technology",
        college: "Bundelkhand University",
        deciplin: "Electronics & communication engineering",
        dateStart: "Apr 2013",
        dateEnd: "June 2017",
        collegeLink: "https://www.bujhansi.ac.in/",
        courseDesc: "Learnt about electronics and communication engineering and basic computer programming and data structures."
    }
]